import React, { type ReactNode } from 'react';
import styled from 'types/theme.types';
import Divider from 'components/common/divider';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';

export type MenuSectionTitle = {
  key: string;
  title: ReactNode;
  isSectionTitle: true;
};

type NavbarMenuSectionTitleProps = {
  item: MenuSectionTitle;
};

const NavbarMenuSectionTitle: React.FunctionComponent<NavbarMenuSectionTitleProps> = ({ item }) => {
  const { isCollapsed } = useNavbarCollapse();

  return (
    <SectionTitleContainer data-e2e={item.key}>
      <Divider margin="0" title={isCollapsed ? undefined : item.title} />
    </SectionTitleContainer>
  );
};

const SectionTitleContainer = styled.div`
  padding: 4px 15px 0;

  && .ant-divider {
    border-block-start-color: ${({ theme }) => theme.tertiaryGray};
  }

  && .ant-divider-inner-text {
    font-size: 11px;
    font-weight: bold;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.lightGray};
  }
`;

export default NavbarMenuSectionTitle;
